'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _withBreakpointResizeListener = require('../hoc/withBreakpointResizeListener');

var _click_or_escape_outside = require('./click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _dropdown_component = require('./global_components/dropdown_component');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _location_service = require('../services/location_service');

var _location_service2 = _interopRequireDefault(_location_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductSelector = function (_React$Component) {
  _inherits(ProductSelector, _React$Component);

  function ProductSelector(props) {
    _classCallCheck(this, ProductSelector);

    var _this = _possibleConstructorReturn(this, (ProductSelector.__proto__ || Object.getPrototypeOf(ProductSelector)).call(this, props));

    _this.state = {
      searchBoxFocus: false
    };
    _this.productSelectorItems = _this.productSelectorItems.bind(_this);
    _this.onChangeEvent = _this.onChangeEvent.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _location_service2.default.setTargetWindowObject(_this.props.window);
    return _this;
  }

  _createClass(ProductSelector, [{
    key: 'getProductSelectorStyle',
    value: function getProductSelectorStyle() {
      var _props = this.props,
          additionalMargin = _props.additionalMargin,
          breakpoint = _props.breakpoint,
          isStickyHeaderVisible = _props.isStickyHeaderVisible;

      var styleClassName = 'width-percent-100 height-45';

      if (isStickyHeaderVisible) {
        styleClassName = 'width-percent-100 position-absolute right-0';
      }

      if (additionalMargin) {
        styleClassName += '' + additionalMargin;
      } else if (breakpoint < 3) {
        styleClassName = 'width-percent-100 padding-vertical-20';
      }

      return styleClassName;
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({
        searchBoxFocus: true
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({
        searchBoxFocus: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var breakpoint = this.props.breakpoint;

      var styleClass = this.getProductSelectorStyle();
      return _react2.default.createElement(
        'div',
        { id: 'product-selector', 'data-testid': 'product-selector',
          onClick: function onClick() {
            return _this2.setState({
              searchBoxFocus: !_this2.state.searchBoxFocus
            });
          },
          className: styleClass + ' ' + (breakpoint < 3 ? "container" : "") + ' print-hide font-slate-grey'
        },
        _react2.default.createElement(
          _click_or_escape_outside2.default,
          { id: 'parentContainer', onClose: this.onBlur },
          _react2.default.createElement(_dropdown_component2.default, {
            dropdownContent: this.productSelectorItems(),
            dropdownWidth: "100%",
            id: (this.props.isStickyHeaderVisible ? "sticky-" : "") + 'product-selector-dropdown',
            className: (this.props.isStickyHeaderVisible ? 'margin-bottom-10' : 'margin-bottom-20') + ' print-hide',
            breakpoint: this.props.breakpoint,
            initialActiveSelect: _string_utility2.default.getLocalizedString(this.props.intl, 'Select Fund', 'pdp-jump-to-a-fund-search-placeholder'),
            alwaysOpenOnSelect: false,
            dataTest: 'product-list-dropdown'
          })
        )
      );
    }
  }, {
    key: 'onChangeEvent',
    value: function onChangeEvent(e) {
      if (this.props.parent === 'aem') {
        _location_service2.default.setAEMNewLocation(e.target.getAttribute("data-cusip"), e.target.getAttribute("data-shareclass-name"), true);
      } else {
        _location_service2.default.setNewLocation(e.target.getAttribute("data-cusip"), e.target.getAttribute("data-shareclass-name"), this.props.basePath, true);
      }
    }
  }, {
    key: 'productSelectorItems',
    value: function productSelectorItems() {
      var _this3 = this;

      if (!this.props.options) {
        return null;
      }

      var sortedOptions = this.props.options.sort(function (a, b) {
        var nameA = (0, _ramda.isNil)(a.translatedFundName) ? "" : a.translatedFundName['zh'];
        var nameB = (0, _ramda.isNil)(b.translatedFundName) ? "" : b.translatedFundName['zh'];
        return nameA.localeCompare(nameB, 'zh-TW');
      });

      return sortedOptions.map(function (item) {
        return _react2.default.createElement(
          'div',
          {
            ref: _this3[item.cusip + 'productDropdown'],
            key: item.cusip,
            'data-cusip': item.cusip,
            'data-category-code': item.categoryCode,
            'data-shareclass-name': item['shareclassName'],
            className: 'dropdown-list-item',
            'data-testid': 'product-selector-dropdown-item',
            onClick: _this3.onChangeEvent,
            role: 'option'
          },
          _react2.default.createElement(
            'span',
            { 'data-cusip': item.cusip, 'data-category-code': item.categoryCode,
              'data-shareclass-name': item['shareclassName'],
              className: 'disclaimer' },
            _this3.getProductName(item)
          )
        );
      });
    }
  }, {
    key: 'getProductName',
    value: function getProductName(item) {
      var productName = item.name;
      var translatedFundName = (item.translatedFundName || {})[this.props.language];
      var translatedShareclassShortName = (item.translatedShareclassShortName || {})[this.props.language];
      if (!(0, _ramda.isNil)(translatedFundName)) {
        productName = translatedFundName;
        if (!(0, _ramda.isNil)(translatedShareclassShortName)) {
          productName = productName + ' - ' + translatedShareclassShortName;
        }
      }
      return productName;
    }
  }]);

  return ProductSelector;
}(_react2.default.Component);

exports.default = (0, _ramda.compose)(function (component) {
  return (0, _reactIntl.injectIntl)(component, { withRef: false });
}, _withBreakpointResizeListener.withBreakpointResizeListener)(ProductSelector);